import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './tools/ToolPage.css'
import './tools/UrlShortenerStats.css'
import { resolveShortLink } from './tools/utils/shortLinkStore'

const ShortLinkRedirect = ({ match }) => {
  const [status, setStatus] = useState('loading')
  const [destination, setDestination] = useState('')
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    let cancelled = false
    resolveShortLink(match.params.id)
      .then((data) => {
        if (cancelled) return
        if (data?.url) {
          setDestination(data.url)
          setPreview(data.preview || null)
          setStatus('confirm')
        } else {
          setStatus('notfound')
        }
      })
      .catch(() => {
        if (!cancelled) setStatus('error')
      })
    return () => {
      cancelled = true
    }
  }, [match.params.id])

  if (status === 'loading') {
    return (
      <div className="tool-page">
        <p>Carregando...</p>
      </div>
    )
  }

  if (status === 'confirm') {
    return (
      <div className="tool-page">
        <h1>Você está saindo do jarder.dev</h1>
        <p className="tool-disclaimer">
          Este link curto leva para o endereço abaixo. Confira se é um
          destino confiável antes de continuar.
        </p>
        <div className="tool-result-card">
          <span className="tool-result-label">Destino</span>
          <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
            {destination}
          </span>
        </div>

        {preview && (preview.title || preview.image) && (
          <div className="url-stats-preview" style={{ marginTop: 16 }}>
            {preview.image && (
              <img src={preview.image} alt="" className="url-stats-preview-image" />
            )}
            <div className="url-stats-preview-text">
              {preview.title && <strong>{preview.title}</strong>}
              {preview.description && <p>{preview.description}</p>}
            </div>
          </div>
        )}

        <button
          type="button"
          className="tool-button"
          onClick={() => {
            window.location.href = destination
          }}
        >
          Continuar para o site
        </button>
      </div>
    )
  }

  return (
    <div className="tool-page">
      <p className="tool-disclaimer">Esse link curto não existe ou já expirou.</p>
      <Link to="/ferramentas/encurtador-url" className="tool-button">
        Criar um novo link curto
      </Link>
    </div>
  )
}

export default ShortLinkRedirect
